import { render, staticRenderFns } from "./LandingParametrage.vue?vue&type=template&id=1bc495d2&scoped=true"
import script from "./LandingParametrage.vue?vue&type=script&lang=js"
export * from "./LandingParametrage.vue?vue&type=script&lang=js"
import style0 from "./LandingParametrage.vue?vue&type=style&index=0&id=1bc495d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc495d2",
  null
  
)

export default component.exports